interface Props {
  color?: string
  width?: number
  height?: number
}

export const SendBackwardIcon = ({ color = '#6F6F6F', width = 22, height = 24 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 16.25C0.947715 16.25 0.5 15.8023 0.5 15.25V1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H15.25C15.8023 0.5 16.25 0.947715 16.25 1.5V15.25C16.25 15.8023 15.8023 16.25 15.25 16.25H1.5Z"
        fill="white"
        stroke={color}
        strokeLinejoin="round"
      />
      <path
        d="M6.75 22.8125C6.19772 22.8125 5.75 22.3648 5.75 21.8125V8.0625C5.75 7.51022 6.19772 7.0625 6.75 7.0625H20.5C21.0523 7.0625 21.5 7.51022 21.5 8.0625V21.8125C21.5 22.3648 21.0523 22.8125 20.5 22.8125H6.75Z"
        fill={color}
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  )
}
